import moment from 'moment'
import store from '@/store'
import {
  UPDATE_TOKEN
} from '@/store/modules/user'
export default {
  /**
   * 动态插入css
   */
  loadStyle(url) {
    const link = document.createElement('link')
    link.type = 'text/css'
    link.rel = 'stylesheet'
    link.href = url
    const head = document.getElementsByTagName('head')[0]
    head.appendChild(link)
  },
  /**
   * 设置浏览器头部标题
   */
  setTitle(title) {
    title = title ? `${title}` : '智慧食堂'
    window.document.title = title
  },
  setTempParam(param) {
    window.temporaryParam = param
  },
  getTempParam() {
    return window.temporaryParam
  },
  delayBack() {
    setTimeout(() => {
      this.$router.back()
    }, 1000)
  },
  formatTime(time) {
    return moment(time).format('YYYY-MM-DD HH:mm:ss')
  },
  formatDateByDate(date) {
    return moment(date).format('YYYY-MM-DD')
  },
  formatDateMDByDate(date) {
    return moment(date).format('MM-DD')
  },
  calendarCalendar(date) {
    const btm = moment(date).set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    }).from(moment().set({
      hour: 0,
      minute: 0,
      second: 0,
      millisecond: 0
    }), 'days')
    if (btm === 'a few seconds') {
      return '(今天)'
    } else if (btm === 'a day') {
      return '(明天)'
    } else if (btm === '2 days') {
      return '(后天)'
    } else {
      return ''
    }
  },
  formatDateDate(date) {
    return moment(date).format('YYYYMMDD')
  },
  startOfADay(date) {
    return moment(date).startOf('day').toDate().getTime()
  },
  datePlusOneDay(date) {
    return moment(date).add(1, 'day').toDate()
  },
  dateMinusOneDay(date) {
    return moment(date).add(-1, 'day').toDate()
  },
  getMonthlyRange(startNum, endNum) { // start: -2, end 0,相当于2个月前到这个月底,总共三个月的时间
    if ((typeof startNum !== 'number') || (typeof endNum !== 'number')) {
      return undefined
    }
    let startTime = moment(new Date()).add(startNum, 'month')
    let endTime = moment(new Date()).add(endNum, 'month')
    let start = startTime.startOf('month')
    let end = endTime.endOf('month')
    return {
      start: Date.parse(start),
      end: Date.parse(end)
    }
  },
  formatPrice(number, companyId) {
    return parseFloat(number / 100).toFixed(2) + '元'
  },
  formatPriceNumber(number) {
    return parseFloat(number / 100).toFixed(2)
  },
  checkTimeReached(timeStamp) {
    let now = new Date().getTime()
    return timeStamp > 0 ? (now > timeStamp) : false
  },
  showLoading(text) {
    window.$app.$emit('loading', text)
  },
  hideLoading() {
    window.$app.$emit('loading', null)
  },
  showToast(message, style, autoCancel = true) {
    window.$app.$emit('toast', message, autoCancel)
  },
  hideToast() {},
  /*
   * eg. data.a.b.c -> data: data, props: ['a', 'b', 'c']
   * @param {Object} data to be check
   * @param {String, Array} props a
   * @return  { Boolean } result
   */
  hasPropertyDeep(data, props) {
    if (!(data instanceof Object)) {
      return false
    }
    if (typeof props === 'string') {
      return data[props] !== null && data[props] !== undefined
    }
    if (!(props instanceof Array)) {
      return false
    }
    let curData = data
    for (let i = 0; i < props.length; i++) {
      curData = curData[props[i]]
      if (i === (props.length - 1)) {
        return curData !== null && curData !== undefined
      }
      if (!(curData instanceof Object)) {
        return false
      }
    }
    return true
  },
  // 接口二次请求
  reLink(code, fn, option) {
    if (code === '11002') {
      store.dispatch(UPDATE_TOKEN).then(() => {
        fn(option)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/util.js